// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"_14t5lQlV3uLJvv6dpm2r0n"};